import { render, staticRenderFns } from "./CardItem.vue?vue&type=template&id=224f1da0&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"
import style0 from "./CardItem.vue?vue&type=style&index=0&id=224f1da0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f1da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224f1da0')) {
      api.createRecord('224f1da0', component.options)
    } else {
      api.reload('224f1da0', component.options)
    }
    module.hot.accept("./CardItem.vue?vue&type=template&id=224f1da0&scoped=true", function () {
      api.rerender('224f1da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/service/flowEfficiency/compontents/CardItem.vue"
export default component.exports